class VideoOverlayHandler {
    constructor(overlaySelector, videoContainerSelectors) {
        this.overlay = document.querySelector(overlaySelector);
        this.videoContainers = document.querySelectorAll(videoContainerSelectors);
        this.init();
    }

    init() {
        if (this.overlay) {
            this.overlay.addEventListener('click', this.toggleVideo.bind(this));
        }
    }

    toggleVideo() {
        this.videoContainers.forEach(container => {
            const iframe = container.querySelector('iframe');
            const video = container.querySelector('video');

            if (iframe) {
                this.toggleIframe(iframe);
            } else if (video) {
                this.toggleVideoElement(video);
            }
        });
    }

    toggleIframe(iframe) {
        const src = iframe.getAttribute('src');
        if (src.includes('autoplay=1')) {
            iframe.setAttribute('src', src.replace('autoplay=1', 'autoplay=0'));
            this.overlay.style.display = 'flex';
        } else {
            iframe.setAttribute('src', src.replace('autoplay=0', 'autoplay=1'));
            this.overlay.style.display = 'none';
        }
    }

    toggleVideoElement(video) {
        if (video.paused) {
            video.play();
            this.overlay.classList.add('hidden');
        } else {
            video.pause();
            this.overlay.classList.remove('hidden');
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const videoOverlayHandler = new VideoOverlayHandler('.video-overlay', '.video-container-mobile, .video-container-desktop');
});
